function getScrollbarWidth() {
  // Gesamte Fensterbreite einschließlich Scrollbalken
  const windowWidth = window.innerWidth

  // Breite des Dokuments ohne Scrollbalken
  const documentWidth = document.documentElement.clientWidth

  // Die Differenz ist die Scrollbalkenbreite

  return windowWidth - documentWidth
}

function setScrollbarWidth() {
  const scrollbarWidth = getScrollbarWidth()
  document.documentElement.style.setProperty('--scrollbar-width', `${scrollbarWidth}px`)
}

// Initial setzen
setScrollbarWidth()

// Bei Größenänderung des Fensters aktualisieren
window.addEventListener('resize', setScrollbarWidth)
